module.exports = "/wwwroot/img/logo_strip_block.png?ver=0e18d533";